import React from 'react'
import MultiFileItem from './../MultiFileItem/MultiFileItem'

const MultiFileList = ({ multiUploadFiles, docUrl, titlePreFix, removeFile }) => {
    let fileList
    if(docUrl !== undefined){
        fileList =  titlePreFix == 'Edit' ? docUrl : multiUploadFiles
    }
    const deleteFileHandler = (_name) => {
            removeFile(_name,"doc")
    }
    return (
        <ul className="file-list">
            {
                fileList &&
                fileList.map(f => (<MultiFileItem
                    key={f.name}
                    file={f}
                    deleteFile={deleteFileHandler} />))
            }
        </ul>
    )
}

export default MultiFileList